import React from "react";
import Header from "../components/common/Header";
import SamplePaper from "../components/SamplePaper";

const SamplePaperPage = () => {
  return (
    <div className="content-card">
      <SamplePaper />
    </div>
  );
};

export default SamplePaperPage;
